import script from "./3pCheckout.vue?vue&type=script&setup=true&lang=js"
export * from "./3pCheckout.vue?vue&type=script&setup=true&lang=js"

import "./3pCheckout.vue?vue&type=style&index=0&id=4113ba27&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4113ba27"]])

export default __exports__